import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import StickerView from '../views/StickerView.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/with-text/:query',
    name: 'with_text',
    component: HomeView,
  },
  {
    path: '/without-text',
    name: 'without_text',
    component: HomeView,
  },
  {
    path: '/sticker/:name',
    name: 'sticker',
    component: StickerView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  },
  routes,
});

export default router;
